import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EscapeConfig } from '../../utils/fila-config.util';

@Injectable({
  providedIn: 'root',
})
export class QueueConfigService {
  private readonly apiURL: string;

  constructor(private httpClient: HttpClient) {
    this.apiURL = `${environment.apiUrl}/v${environment.apiVersion}/queue-config`;
  }

  async getGroupOrder(clinicId: number): Promise<string | null> {
    try {
      const result = await firstValueFrom(
        this.httpClient
          .get<any>(`${this.apiURL}/${clinicId}/group-order`)
          .pipe(catchError(this.handleError)),
      );
      return result?.data?.[0] ?? null;
    } catch {
      return null;
    }
  }

  async saveGroupOrder(
    clinicId: number,
    groupOrder: string[],
    username: string,
    weights?: Record<string, number>,
    escape?: EscapeConfig,
  ): Promise<void> {
    try {
      const hasWeights = weights && Object.keys(weights).length > 0;
      const hasEscape  = escape?.enabled === true;
      let payload: string;
      if (hasWeights || hasEscape) {
        const body: any = { order: groupOrder };
        if (hasWeights) body.weights = weights;
        if (hasEscape) body.escape = escape;
        payload = JSON.stringify(body);
      } else {
        payload = JSON.stringify(groupOrder);
      }
      await firstValueFrom(
        this.httpClient
          .put(`${this.apiURL}/${clinicId}/group-order`, { groupOrder: payload, username })
          .pipe(catchError(this.handleError)),
      );
    } catch {
      // falha silenciosa — localStorage já foi atualizado
    }
  }

  async getQueueConfig(clinicId: number): Promise<{ groupOrder: string; novaOrdem: boolean }> {
    try {
      const result = await firstValueFrom(
        this.httpClient
          .get<any>(`${this.apiURL}/${clinicId}`)
          .pipe(catchError(this.handleError)),
      );
      const data = result?.data?.[0];
      return { groupOrder: data?.groupOrder ?? '', novaOrdem: data?.novaOrdem === true };
    } catch {
      return { groupOrder: '', novaOrdem: true };
    }
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
